module.exports = __webpack_public_path__ + "static/img/sicbo_th.6ec0f02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa/sicbo_th.png
// module id = cuWy
// module chunks = 1